export default __webpack_public_path__ + "static/media/product-17.9ccc96fd.webp";